import { Component, OnInit, Input } from '@angular/core';
import { Report } from '../../model/report.model';

@Component({
  selector: 'app-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.less']
})
export class ReportHeaderComponent implements OnInit {
  @Input() report: Report;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/report-header/report-header.component.ts